import React, { PureComponent } from 'react'
import { string, bool, any } from 'prop-types'
import { capitalize } from 'utils/string'

import './Text.css'

export class Text extends PureComponent {
    static propTypes = {
        color: string,
        children: any,
        className: string,
        weigth: string,
        uppercase: bool,
        tag: string
    }

    static defaultProps = {
        uppercase: false,
        tag: 'p'
    }

    render() {
        const { weigth, color, className, children, uppercase, tag: Tag, ...otherProps } = this.props
        return (
            <Tag
                className={[
                    'Text',
                    className,
                    color && capitalize(color),
                    weigth && capitalize(weigth),
                    {
                        Uppercase: uppercase
                    }
                ]}
                {...otherProps}
            >
                {children}
            </Tag>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Text/Text.js